import { useMutation } from "@tanstack/react-query";
import apiInstance from "api/aiInstance";

const useUpdateSessionTitle = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationKey: ["updateSessionTitle"],
        mutationFn: async ({
            sessionId,
            title,
        }: {
            sessionId: number;
            title: string;
        }) => {
            await apiInstance.put(`api/v1/update-agent-session/${sessionId}`, {
                title,
            });
        },
    });
    return {
        updateSessionTitle: mutateAsync,
        isLoading: isPending,
    };
};

export default useUpdateSessionTitle;
